import { createPortal } from 'react-dom';
import Icon from '@/components/Icon';
import { dismissToast, useToast } from '@/lib/toast';

// The current toast (lib/toast.ts) as a pill at the bottom of the window,
// over every page. Clicks pass through it, except on its action button.
export default function ToastHost() {
  const toast = useToast();
  if (!toast) return null;
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      style={{ position: 'fixed', left: 0, right: 0, bottom: 28, zIndex: 200, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }}
    >
      <div
        key={toast.id}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          maxWidth: 'min(88vw, 520px)',
          padding: '11px 18px',
          borderRadius: 999,
          background: 'var(--ink)',
          color: 'var(--bg)',
          boxShadow: 'var(--shadow-panel)',
          fontFamily: 'var(--font-ui)',
          fontSize: 13.5,
          fontWeight: 500,
          animation: 'wa-fade-up var(--dur) var(--ease)',
        }}
      >
        <Icon name="check" size={15} />
        {toast.message}
        {toast.action ? (
          <button
            type="button"
            onClick={() => {
              const act = toast.action;
              dismissToast();
              act?.onClick();
            }}
            style={{
              pointerEvents: 'auto',
              marginLeft: 6,
              padding: '2px 10px',
              border: '1px solid currentColor',
              borderRadius: 999,
              background: 'transparent',
              color: 'inherit',
              font: 'inherit',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {toast.action.label}
          </button>
        ) : null}
      </div>
    </div>,
    document.body,
  );
}
